export const pkg = {
  packageQuoteSelectedPlan: (state) => {
    if (state.quotation.packageForm.planNo && state.quotation.packageParam.plans.plans && state.quotation.packageParam.plans.plans.length > 0) {
      const selectedPlan = state.quotation.packageParam.plans.plans.find(x => x.planNo === state.quotation.packageForm.planNo)
      if (selectedPlan) {
        return selectedPlan
      }
    }
    return null
  }
}
